// import * as firebase from "firebase";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

import { firebaseConfig } from "./firebaseKey";

firebase.initializeApp(firebaseConfig);

export const fbAuth = firebase.auth();
export const fbDB = firebase.database();
